if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;



	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
"extensions_cornerstone-dicom-pmap_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomT-320ba8": 1,
"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx-extensions_defaul-4d563c": 1,
"extensions_cornerstone-dicom-seg_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTa-adb9f8": 1,
"extensions_cornerstone-dicom-sr_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTag-992e72": 1,
"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx": 1,
"extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-extensions_default_src_utils_color-4e030c": 1,
"extensions_dicom-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var extractCssOldTags = [];
var extractCssNewTags = [];
var extractCssApplyHandler = function (options) {
	return {
		dispose: function () {},
		apply: function () {
			for (var i = 0; i < extractCssNewTags.length; i++) extractCssNewTags[i].sheet.disabled = false;
			for (var i = 0; i < extractCssOldTags.length; i++) {
				var oldTag = extractCssOldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			extractCssOldTags.length = 0;
			extractCssNewTags.length = 0;
		}
	}
}
var extractCssInitialChunkIds = {"cornerstone3d_packages_core_dist_esm_index_js-data_text_javascript_import_20_7B_20init_20_7D_-68d93d": 1,"index": 1,"lib-react": 1,"lib-router": 1,"vendors-cornerstone3d_node_modules_cornerstonejs_calculate-suv_dist_calculate-suv_esm_js-corn-109ced": 1,"vendors-node_modules_ant-design_icons_es_index_js-node_modules_radix-ui_react-icons_dist_reac-552a22": 1,"vendors-node_modules_buffer_index_js": 1,"vendors-node_modules_fast-deep-equal_index_js-node_modules_gl-matrix_esm_index_js": 1,"vendors-node_modules_process_browser_js-cornerstone3d_node_modules_comlink_dist_esm_comlink_mjs": 1,"vendors-node_modules_rsbuild_core_dist_client_overlay_js": 1,};
// A chunk is present on this page only when the active JavaScript
// chunk-loading runtime records it as fully loaded.
var extractCssChunkIsLoaded = function (chunkId) {
	return typeof __webpack_require__.hmrS_jsonp !== "undefined" && __webpack_require__.hmrS_jsonp && __webpack_require__.hmrS_jsonp[chunkId] === 0;
};
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList, css, miniCss) {
	applyHandlers.push(extractCssApplyHandler);
	/**
		`miniCss` is the hot-update manifest's namespace for extracted CSS:
		`miniCss.c` lists the chunks whose extracted CSS content actually changed
		and `miniCss.r` the chunks whose extracted CSS disappeared. It is kept
		apart from the native css runtime's `css` namespace so neither runtime
		reacts to the other's stylesheets. Its absence means this update carries
		no extracted CSS work at all — notably the runtime chunk is in `chunkIds`
		on every update (its full hash always changes) while its stylesheet
		rarely does.
	 */
	var cssRemovedChunkIds = (miniCss && miniCss.r) || [];
	var cssChunkIds = (miniCss && miniCss.c) || [];
	var seen = {};
	cssRemovedChunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		if (!href) return;
		var oldTag = extractCssFindStylesheet(href, __webpack_require__.p + href);
		if (oldTag) extractCssOldTags.push(oldTag);
	});
	cssChunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		if (!href) return;
		var fullhref = __webpack_require__.p + href;
		if (seen[fullhref]) return;
		seen[fullhref] = true;
		var oldTag = extractCssFindStylesheet(href, fullhref);
		// The manifest is computed from the compilation and also lists chunks this
		// page never loaded. A missing tag is legitimate only for a chunk that is
		// actually on the page: an initial chunk gaining its first stylesheet, or
		// a loaded async chunk whose stylesheet was removed by an earlier update.
		if (!oldTag && !extractCssInitialChunkIds[chunkId] && !extractCssChunkIsLoaded(chunkId)) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = extractCssCreateStylesheet(
				chunkId,

				/**
					Use a query to bypass the browser cache: with an existing link the
					browser may treat the new tag as the same resource and skip fetching
					(this can happen during lazy compilation, same strategy as the
					updateCss API), and even without a current link the stable filename
					may still be cached from before the stylesheet was removed.
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.sheet.disabled = true;
					if (oldTag) extractCssOldTags.push(oldTag);
					extractCssNewTags.push(tag);
					resolve();
				},
				reject
			);
		}))
	});
}

__webpack_require__.F.miniCss = (chunkId) => {
  if ((!__webpack_require__.o(installedCssChunks, chunkId) || installedCssChunks[chunkId] === undefined) && /^(extensions_(cornerstone(\-dicom\-(pmap_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomT\-320ba8|rt_src_viewports_OHIFCornerstoneRTViewport_tsx\-extensions_defaul\-4d563c|seg_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomTa\-adb9f8|sr_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomTag\-992e72)|_src_Viewport_OHIFCornerstoneViewport_tsx)|default_src_DicomTagBrowser_DicomTagBrowser_css\-extensions_default_src_utils_color\-4e030c|dicom\-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx)|index)$/.test(chunkId)) {
    installedCssChunks[chunkId] = null;

    var link = document.createElement('link');

if (__webpack_require__.nc) {
  link.setAttribute('nonce', __webpack_require__.nc);
}
link.rel = "prefetch";
link.as = "style";
link.href = __webpack_require__.p + __webpack_require__.miniCssF(chunkId);

    document.head.appendChild(link);
  }
};
// no preload